import { render } from "./Trading.vue?vue&type=template&id=2e8c36b8&scoped=true"
import script from "./Trading.vue?vue&type=script&lang=js"
export * from "./Trading.vue?vue&type=script&lang=js"

import "./Trading.vue?vue&type=style&index=0&id=2e8c36b8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e8c36b8"]])

export default __exports__